import type { Tile } from "../engine";
import { isBridgeRoadTile } from "./roadBridgeDetection";

const bridgeCacheByTiles = new WeakMap<readonly Tile[], Map<string, boolean>>();

function bridgeCacheFor(tiles: readonly Tile[]): Map<string, boolean> {
  let cache = bridgeCacheByTiles.get(tiles);
  if (!cache) {
    cache = new Map();
    bridgeCacheByTiles.set(tiles, cache);
  }
  return cache;
}

export function isSeaShoreLandAt({
  tiles,
  width,
  x,
  y,
  tile,
}: {
  tiles: readonly Tile[];
  width: number;
  x: number;
  y: number;
  tile: Tile | undefined;
}): boolean {
  if (tile === undefined || tile.kind === "sea") return false;
  if (tile.kind !== "road") return true;
  return !isBridgeRoadTile({ tiles, width, x, y, bridgeCache: bridgeCacheFor(tiles) });
}

export function isSeaShoreRenderAt({
  tiles,
  width,
  x,
  y,
}: {
  tiles: readonly Tile[];
  width: number;
  x: number;
  y: number;
}): boolean {
  const tile = tiles[y * width + x];
  if (!tile) return false;
  if (tile.kind === "sea") return true;
  return (
    tile.kind === "road" &&
    isBridgeRoadTile({ tiles, width, x, y, bridgeCache: bridgeCacheFor(tiles) })
  );
}
